enum ThematicMapLayerRangeType {
  Continuous = "Continuous",
  Discrete = "Discrete",
}

export default ThematicMapLayerRangeType;
